import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import themesJS from "./themes.js";

// Translation provided by Vuetify (javascript)
import es from "vuetify/es5/locale/es";
import en from "vuetify/es5/locale/en";
import fr from "vuetify/es5/locale/fr";
import de from "vuetify/es5/locale/de";
import i18n from "../lang/i18n";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: themesJS
    }
  },
  icons: {
    iconfont: "fa"
  },
  lang: {
    locales: { es, en, fr, de },
    current: i18n.locale
  }
};

export default new Vuetify(opts);
